import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// Generiek "⋯ Meer"-menu voor secundaire acties. items: [{ label, icon, onClick, disabled, danger, testid, hint }] of "separator".
export default function MoreMenu({ items, label = "Meer", testid = "more-menu", size = "md", align = "end" }) {
  const pad = size === "sm" ? "px-3 py-1.5 text-xs" : "px-3 py-3 text-sm";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={testid} title={label}
          className={`btn-brutal bg-background text-foreground ${pad} font-display uppercase font-black inline-flex items-center gap-2`}>
          <MoreHorizontal className="w-4 h-4" /> {label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-64 border-2 border-foreground rounded-none heavy-shadow p-1">
        {items.filter(Boolean).map((it, i) => it === "separator" ? <DropdownMenuSeparator key={`sep-${i}`} /> : (
          <DropdownMenuItem key={it.testid || it.label} disabled={it.disabled} onSelect={() => it.onClick?.()} data-testid={it.testid}
            title={it.hint} className={`rounded-none cursor-pointer font-display uppercase font-bold text-xs tracking-wide gap-2 py-2 ${it.danger ? "text-destructive focus:text-destructive" : ""}`}>
            {it.icon}
            <span className="flex-1">{it.label}</span>
            {it.hint && <span className="text-[9px] normal-case tracking-normal text-muted-foreground font-sans">{it.hint}</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
